import React from 'react';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { translate } from '../../../../types/translation/Translator';
import AuthenticationSettingsView from './AuthenticationSettings/AuthenticationSettingsView';
import DeleteCompanyView from './DeleteCompany/DeleteCompanyView';
import DeveloperSettingsView from './DeveloperSettings/DeveloperSettingsView';
import CompanySuperUserSettingsPane from './CompanySuperUserSettings/CompanySuperUserSettingsPane';

export default function SecuritySettingsScreen() {
  return (
    <div className='content-x content-y-screen flex-grow overflow-auto'>
      <div className='grid gap-8'>
        <p className='page-title'>{translate({ key: TranslationKey.securityAndAccess })}</p>

        <AuthenticationSettingsView />
        <DeveloperSettingsView />
        <DeleteCompanyView />
        <CompanySuperUserSettingsPane />
      </div>
    </div>
  );
}
